// --- Our Modules --------------------------------------------------------------------------------
import type { TyIconName } from "./types";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = { name: TyIconName; size?: number };

/**
 * The icons live in `public/icons` and are painted as a CSS mask rather than an `<img>`, so one file
 * serves every state — an active tab is gold and an idle one is navy without shipping two copies of
 * the same art, and the same file works on the dark sidebar and on a white card.
 */
export default function Icon({ name, size = 24 }: Props) {
    return (
        <span
            className="icon"
            style={{ width: size, height: size, maskImage: `url(/icons/${name}.svg)`, WebkitMaskImage: `url(/icons/${name}.svg)` }}
        />
    );
}
